import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BkButton from '../../Components/ui/BkButton';
import BkPage from '../../Components/ui/BkPage';
import BkPanel from '../../Components/ui/BkPanel';
import { useAuthContext } from '../../contexts/AuthContext';
import usePageMeta from '../../hooks/use-page-meta';
import { profileTabPath } from '../Profile/profile-tabs';

/** Legacy route — preferences now live on the profile hub. */
export default function Settings() {
  usePageMeta({
    title: 'Settings',
    description: 'Blind Kings account preferences.',
    path: '/settings',
    noindex: true,
  });

  const navigate = useNavigate();
  const { currentUser, userData, openLoginModal } = useAuthContext();
  const displayName = userData?.displayName;

  useEffect(() => {
    if (currentUser && displayName) {
      navigate(profileTabPath(String(displayName), 'preferences'), {
        replace: true,
      });
    }
  }, [currentUser, displayName, navigate]);

  return (
    <BkPage narrow>
      <BkPanel className="space-y-4 text-center">
        <h1 className="text-2xl font-bold uppercase tracking-wider text-bk-gold">
          Preferences moved
        </h1>
        <p className="text-sm text-bk-muted">
          Skins, emotes, and board preferences now live on your profile.
        </p>
        {!currentUser ? (
          <BkButton variant="primary" onClick={openLoginModal}>
            Sign in
          </BkButton>
        ) : !displayName ? (
          <p className="text-sm text-bk-muted animate-bk-pulse-soft">
            Loading your profile…
          </p>
        ) : null}
      </BkPanel>
    </BkPage>
  );
}
